{
  "familyId": "TAA-LEZEN-STRUCTUUR",
  "questions": [
    {
      "id": "TAA-LEZEN-STRUCTUUR-001",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "text_highlight",
      "question": "Lees de tekst. Markeer eerst de zin die het PROBLEEM beschrijft, en daarna de zin die de OPLOSSING beschrijft.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Elk jaar belandt er miljoenen tonnen plastic in de oceaan. Veel zeedieren raken erin verstrikt of eten het op en gaan dood. Wetenschappers werken aan een speciale boot die het plastic uit het water vist. Als die boot werkt, kunnen we de oceanen weer schoonmaken.",
        "correctHighlights": [
          { "start": 0, "end": 58, "text": "Elk jaar belandt er miljoenen tonnen plastic in de oceaan." },
          { "start": 124, "end": 203, "text": "Wetenschappers werken aan een speciale boot die het plastic uit het water vist." }
        ]
      },
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "Elk jaar belandt er miljoenen tonnen plastic in de oceaan. Veel zeedieren raken erin verstrikt of eten het op en gaan dood. Wetenschappers werken aan een speciale boot die het plastic uit het water vist. Als die boot werkt, kunnen we de oceanen weer schoonmaken.",
            "instruction": "Lees de tekst en markeer probleem + oplossing",
            "source": "Voorbeeldtekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "textStructureSchema",
          "showWhen": "wrong",
          "data": {
            "structure": "probleem-oplossing"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie",
            "content": "Zoek eerst signaalwoorden zoals 'probleem', 'daarom' of 'oplossing'. Markeer dan de zin die het probleem noemt (wat er mis is) en de zin die zegt hoe je het probleem aanpakt (de oplossing).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "structuur_probleem_oplossing_highlight",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De eerste zin beschrijft het probleem: plastic in de oceaan dat zeedieren doodt. De zin over wetenschappers en de speciale boot beschrijft de oplossing. Samen vormen ze de probleem-oplossing structuur. Check: de probleemzin staat altijd vóór de oplossingszin en beschrijft wat er mis is.",
        "solutionSteps": [
          "Lees de hele tekst rustig door.",
          "Vraag: wat is het probleem? Markeer die zin.",
          "Vraag: wat is de oplossing? Markeer die zin.",
          "Check: staat het probleem eerst en de oplossing daarna? Dan is de structuur probleem-oplossing."
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "TAA-LEZEN-STRUCTUUR-002",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "categorize",
      "question": "Sorteer deze signaalwoorden onder de juiste tekststructuur.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Opsomming", "Oorzaak-gevolg", "Tegenstelling", "Chronologisch"],
        "items": [
          { "text": "ten eerste", "correctCategory": 0 },
          { "text": "daarom", "correctCategory": 1 },
          { "text": "echter", "correctCategory": 2 },
          { "text": "vervolgens", "correctCategory": 3 },
          { "text": "bovendien", "correctCategory": 0 },
          { "text": "hierdoor", "correctCategory": 1 },
          { "text": "in tegenstelling tot", "correctCategory": 2 },
          { "text": "daarna", "correctCategory": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: wat doet het signaalwoord?",
            "content": "Vraag bij elk woord: voegt het iets toe (opsomming), legt het een verband oorzaak→gevolg, zet het iets tegenover elkaar (tegenstelling), of geeft het een tijdsvolgorde aan (chronologisch)?",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "structuur_signaalwoorden_categorize",
      "variantIndex": 2,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Opsomming: 'ten eerste', 'bovendien' (voegt iets toe). Oorzaak-gevolg: 'daarom', 'hierdoor' (gevolg). Tegenstelling: 'echter', 'in tegenstelling tot' (zet iets tegenover). Chronologisch: 'vervolgens', 'daarna' (tijdsvolgorde).",
        "solutionSteps": [
          "Opsomming-signalen voegen toe: ten eerste, bovendien.",
          "Oorzaak-gevolg-signalen geven een gevolg aan: daarom, hierdoor.",
          "Tegenstelling-signalen zetten iets tegenover elkaar: echter, in tegenstelling tot.",
          "Chronologisch-signalen geven tijdsvolgorde aan: vervolgens, daarna."
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.structuur-signaal-verkeerde-categorie", "label": "Signaalwoord in verkeerde structuur-categorie geplaatst" }
        ]
      }
    },
    {
      "id": "TAA-LEZEN-STRUCTUUR-003",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "multiple_choice",
      "question": "Lees de tekst hierboven. Welke tekststructuur gebruikt deze tekst?",
      "options": ["Vergelijking", "Opsomming", "Probleem-oplossing", "Oorzaak-gevolg"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "In de stad zijn veel winkels, restaurants en bioscopen. Op het platteland vind je vooral natuur, weilanden en rust. Stadsmensen reizen kort naar hun werk; plattelandsbewoners moeten vaak ver rijden. Toch hebben beide hun voordelen — de stad biedt drukte, het platteland biedt ruimte.",
            "instruction": "Lees de tekst",
            "source": "Voorbeeldtekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "textStructureSchema",
          "showWhen": "wrong",
          "data": {
            "structure": "vergelijking",
            "labels": ["Stad", "Platteland"]
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: vergelijking",
            "content": "Zoek woorden die twee dingen tegenover elkaar zetten: 'maar', 'terwijl', 'toch', 'beide', 'in tegenstelling tot'. Als de tekst twee dingen naast elkaar legt, is het een vergelijking.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "structuur_vergelijking_in_context",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De tekst zet stad en platteland naast elkaar (winkels vs natuur, kort reizen vs ver rijden, drukte vs ruimte). Het signaalwoord 'toch' en de structuur 'beide hebben hun voordelen' maken duidelijk dat dit een vergelijking is. Check: als je twee onderwerpen telt en ze worden punt-voor-punt afgewogen, is het een vergelijking.",
        "solutionSteps": [
          "Welke twee dingen worden besproken? Stad en platteland.",
          "Worden ze tegenover elkaar gezet? Ja: winkels vs natuur, kort vs ver rijden.",
          "Welke signaalwoorden zie je? 'Toch', 'beide'.",
          "Conclusie: vergelijking.",
          "Check: twee onderwerpen + tegenstellings-signalen ⇒ vergelijking."
        ],
        "distractorExplanations": {
          "0": "Goed! De tekst legt stad en platteland naast elkaar — dat is een vergelijking.",
          "1": "Bij opsomming wordt een rij dingen genoemd, maar hier worden twee dingen telkens tegenover elkaar gezet. Let op het woord 'toch' en de tegenstellingen.",
          "2": "Er is geen duidelijk probleem en geen oplossing in de tekst. Er worden alleen twee leefomgevingen vergeleken.",
          "3": "Er staat geen 'daarom' of 'hierdoor' in de tekst. Er wordt niet uitgelegd dat het ene het andere veroorzaakt — alleen vergeleken."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.structuur-opsomming-vs-vergelijking", "label": "Verwart opsomming met vergelijking", "optionIndex": 1 },
          { "id": "taa.structuur-probleem-vs-vergelijking", "label": "Verwart probleem-oplossing met vergelijking", "optionIndex": 2 },
          { "id": "taa.structuur-oorzaak-vs-vergelijking", "label": "Verwart oorzaak-gevolg met vergelijking", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-LEZEN-STRUCTUUR-004",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "multiple_choice",
      "question": "Lees de tekst hierboven. Welke tekststructuur gebruikt deze tekst?",
      "options": ["Chronologisch", "Oorzaak-gevolg", "Vergelijking", "Probleem-oplossing"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "In 1939 begon de Tweede Wereldoorlog toen Duitsland Polen binnenviel. Een jaar later, in 1940, werd Nederland bezet. In de jaren daarna breidde de oorlog zich uit over heel Europa. In 1944 landden de geallieerden in Normandië. Vijf jaar na het begin, in 1945, eindigde de oorlog eindelijk.",
            "instruction": "Lees de tekst",
            "source": "Voorbeeldtekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "textStructureSchema",
          "showWhen": "wrong",
          "data": {
            "structure": "chronologisch",
            "labels": ["1939", "1940-1944", "1945"]
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: chronologisch",
            "content": "Zoek tijdsaanduidingen: jaartallen, 'eerst', 'daarna', 'later', 'eindelijk'. Als de tekst gebeurtenissen op tijdsvolgorde plaatst, is het chronologisch.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "structuur_chronologisch_in_context",
      "variantIndex": 4,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De tekst plaatst gebeurtenissen op tijdsvolgorde: 1939 → 1940 → 1944 → 1945. Signaalwoorden 'in 1939', 'een jaar later', 'in de jaren daarna', 'eindelijk' bevestigen de chronologische structuur. Check: kun je elke zin op een tijdlijn zetten? Dan is de structuur chronologisch.",
        "solutionSteps": [
          "Welke jaartallen of tijdsaanduidingen staan er? 1939, 1940, 1944, 1945.",
          "Staan ze op volgorde? Ja, van vroeger naar later.",
          "Welke signaalwoorden zie je? 'In ...', 'een jaar later', 'daarna', 'eindelijk'.",
          "Conclusie: chronologisch.",
          "Check: tijdlijn-toets — past elke zin op een tijdlijn? Ja ⇒ chronologisch."
        ],
        "distractorExplanations": {
          "0": "Goed! Gebeurtenissen op tijdsvolgorde = chronologisch.",
          "1": "Hoewel oorlogsgebeurtenissen oorzaken en gevolgen kunnen hebben, ligt hier de nadruk op de tijdsvolgorde. De structuur is daarom chronologisch.",
          "2": "Er worden geen twee dingen naast elkaar gezet. De tekst volgt één tijdlijn.",
          "3": "Er wordt geen probleem genoemd dat opgelost wordt. De tekst beschrijft gewoon gebeurtenissen op volgorde."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.structuur-oorzaak-vs-chronologisch", "label": "Verwart oorzaak-gevolg met chronologisch", "optionIndex": 1 },
          { "id": "taa.structuur-vergelijking-vs-chronologisch", "label": "Verwart vergelijking met chronologisch", "optionIndex": 2 },
          { "id": "taa.structuur-probleem-vs-chronologisch", "label": "Verwart probleem-oplossing met chronologisch", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-LEZEN-STRUCTUUR-005",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "matching",
      "question": "Koppel elke tekststructuur aan het juiste signaalwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {"leftItems": ["Oorzaak-gevolg", "Vergelijking", "Opsomming", "Chronologisch"], "rightItems": ["ten eerste", "daardoor", "vervolgens", "in tegenstelling tot"], "correctMatches": {"0": 1, "1": 3, "2": 0, "3": 2}},
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Check-strategie: signaalwoorden", "content": "Vraag bij elk signaalwoord: legt het een gevolg, contrast, volgorde of tijd uit? Oorzaak-gevolg: daardoor. Vergelijking: in tegenstelling tot. Opsomming: ten eerste. Chronologisch: vervolgens.", "icon": "lightbulb"}}],
      "conceptId": "structuur_signaalwoorden_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Oorzaak-gevolg → daardoor (gevolg-woord). Vergelijking → in tegenstelling tot (contrast-woord). Opsomming → ten eerste (volgorde-woord). Chronologisch → vervolgens (tijd-woord).",
        "solutionSteps": ["Oorzaak-gevolg: daardoor (gevolg)", "Vergelijking: in tegenstelling tot (contrast)", "Opsomming: ten eerste (volgorde)", "Chronologisch: vervolgens (tijd)"]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "TAA-LEZEN-STRUCTUUR-006",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "categorize",
      "question": "Sorteer deze kenmerken: welke horen bij een chronologische structuur, en welke niet?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Chronologisch", "Niet chronologisch"],
        "items": [
          { "text": "De tekst vertelt gebeurtenissen op volgorde van tijd.", "correctCategory": 0 },
          { "text": "Er staan jaartallen of tijdsaanduidingen in de tekst.", "correctCategory": 0 },
          { "text": "De schrijver geeft argumenten voor een mening.", "correctCategory": 1 },
          { "text": "Signaalwoorden zijn 'eerst', 'toen', 'daarna'.", "correctCategory": 0 },
          { "text": "De tekst vergelijkt twee dingen met elkaar.", "correctCategory": 1 },
          { "text": "Er staat een tijdlijn in de tekst.", "correctCategory": 0 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: is dit echt chronologisch?",
            "content": "Chronologisch = tijdsvolgorde. Vraag bij elk kenmerk: gaat dit over WANNEER iets gebeurt (chronologisch) of over WAAROM of WAARVAN (andere structuur)?",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "structuur_chronologisch_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Chronologisch: tijdsvolgorde, jaartallen, 'eerst/toen/daarna', een tijdlijn. Niet chronologisch: argumenten geven (betoog), twee dingen vergelijken (vergelijking).",
        "solutionSteps": [
          "Chronologisch herken je aan tijdsaanduidingen en volgorde.",
          "Argumenten voor een mening = betoog, niet chronologisch.",
          "Twee dingen vergelijken = vergelijking, niet chronologisch.",
          "Tijdlijn, jaartallen, 'eerst-daarna' = chronologisch."
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.structuur-chronologisch-kenmerk-verward", "label": "Kenmerk van andere structuur aan chronologisch toegeschreven" },
          { "id": "taa.structuur-niet-chronologisch-gemist", "label": "Chronologisch kenmerk niet herkend" }
        ]
      }
    },
    {
      "id": "TAA-LEZEN-STRUCTUUR-007",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "multiple_choice",
      "question": "Bekijk het schema. Welke tekststructuur is hier afgebeeld?",
      "options": ["Probleem-oplossing", "Oorzaak-gevolg", "Vergelijking", "Chronologisch"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "textStructureSchema",
          "showWhen": "always",
          "data": {
            "structure": "probleem-oplossing"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: schema lezen",
            "content": "Lees de labels op de blokken. Tel het aantal blokken. Kijk naar de richting van de pijl (enkel, dubbel, drie-staps).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "structuur_schema_herkenning",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Het schema toont twee blokken: 'Probleem' en 'Oplossing', verbonden door een pijl. Dit is precies de probleem-oplossingstructuur. Check: lees de labels (Probleem / Oplossing) en tel de blokken (2) — dat matcht alleen probleem-oplossing.",
        "solutionSteps": [
          "Schema = Probleem → Oplossing",
          "Twee blokken, één pijl van links naar rechts",
          "Structuur = probleem-oplossing",
          "Check: labels + aantal blokken + pijlrichting → eenduidige structuur."
        ],
        "distractorExplanations": {
          "0": "Goed! Probleem → Oplossing is precies wat het schema toont.",
          "1": "Je dacht aan oorzaak-gevolg. Maar dat schema heeft de blokken 'Oorzaak' en 'Gevolg' (niet 'Probleem' en 'Oplossing'). Lees de labels van de blokken.",
          "2": "Je dacht aan vergelijking. Maar een vergelijkingsschema heeft een dubbele pijl (⇄) tussen de blokken, geen enkele pijl naar rechts.",
          "3": "Je dacht aan chronologisch. Maar een chronologisch schema heeft drie blokken (1 → 2 → 3), niet twee."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.structuur-schema-vs-oorzaak", "label": "Negeert blok-labels en kiest oorzaak-gevolg", "optionIndex": 1 },
          { "id": "taa.structuur-schema-vs-vergelijking", "label": "Negeert pijl-richting en kiest vergelijking", "optionIndex": 2 },
          { "id": "taa.structuur-schema-vs-chronologisch", "label": "Negeert aantal blokken en kiest chronologisch", "optionIndex": 3 }
        ]
      }
    }
  ]
}